<template>
  <div>
    <modal-provider
      name="auth-modal"
      :title="title"
      :width="625"
      @before-open="beforeOpen"
      classList="modal--auth title-center"
    >
      <div ref="modal" class="modal modal--auth" tabindex="0">
        <authForm
          :redirect-url="redirectUrl"
          :is-ajax-auth="isAjaxAuth"
          :referrer="referrer"
          is-auth-modal
          ref="authForm"
        ></authForm>
      </div>
    </modal-provider>
  </div>
</template>

<script>
import authForm from './AuthForm'

export default {
  name: 'AuthModal',
  components: {
    authForm
  },
  data: function () {
    return {
      title: null,
      isAjaxAuth: false,
      referrer: '',
      redirectUrl: ''
    }
  },
  methods: {
    beforeOpen (event) {
      this.title = event.params?.title || this.$t('auth_modal_title')
      this.isAjaxAuth = event.params?.isAjaxAuth || false
      this.referrer = event.params?.referrer || ''
      this.redirectUrl = event.params?.url || ''
    },
    openSocialAuth (e) {
      window.open(
        e.currentTarget.getAttribute('href'),
        '_blank',
        'width= 860,height=480'
      )
    }
  }
}
</script>

<style lang="sass" scoped>
::v-deep .modal__title
  margin-bottom: 0
</style>
